import React, { useRef, useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import moment from 'moment/moment';
import { useReactToPrint } from 'react-to-print';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagemFichas from '../../../components/TabelaListagemFichas/TabelaListagemFichas';

//Helpers
import { showMessage } from '../../../helpers/message';

//Context
import { useAuth } from '../../../context/auth';

export default function RelatorioMapaEstatistico({ dadosRelatorio, btnVoltar, filtros }) {
    const { setupVariavel, session } = useAuth();
    const refRelatorio = useRef();

    //Cabeçalhos para a listagem das coletas por meio do cardRelatorio
    const headersItemsMapa = [
        { value: "Período", objectValue: "periodo" },
        { value: "Agrupador 1", objectValue: "agrupador1" },
        { value: "Agrupador 2", objectValue: "agrupador2" },
        { value: "Quantidade de Coletas Efetuadas", objectValue: "qtdColetasEfetuadas" },
        { value: "Peso Total Coletado", objectValue: "pesoTotalColetado" },
    ];

    //Função assionada assim que o botão de imprimir pdf é clicado
    const handlePrint = useReactToPrint({
        content: () => refRelatorio.current,
        copyStyles: true,
        documentTitle: "Relatório de mapa estatístico",
    });

    return (
        <MainCard btnVoltarInTop={btnVoltar} btnImprimir={handlePrint}>
            <div className="mt-4 relatorio w-100" ref={refRelatorio}>
                <div className="print m-2 d-flex align-items-center justify-content-between">
                    <p>Emitido por: {session.nome}</p>
                    <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
                </div>
                {setupVariavel?.logoTipo &&
                    <div className="d-flex align-items-center justify-content-center">
                        <img src={"data:image/png;base64," + setupVariavel?.logoTipo} style={{ maxWidth: '70%'}} />
                    </div>
                }
                <div className="header">
                    <h4 className='text-black'>Relatório de mapa estatístico</h4>
                    <Row>
                        <div className='col-4'>
                            <p><span className="fw-bold">Data final:</span> {moment(filtros.dataFinal).format("DD/MM/YYYY")}</p>
                        </div>
                        <div className='col-4'>
                            <p><span className="fw-bold">Tipo do relatório:</span> {filtros.tipo}</p>
                        </div>
                    </Row> 
                    <Row>
                        <div className='col-4'>
                            <p><span className="fw-bold">Agrupamento:</span> {filtros.agrupamento}</p>
                        </div>
                    </Row>
                </div>
                <div className="body">
                    <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>MAPA ESTATÍSTICO</h5>
                    <TabelaListagemFichas scrollbar={false} headers={headersItemsMapa} items={dadosRelatorio.itemsMapa} />
                </div>
            </div>
        </MainCard>
    )
}